// Configuration values

// Access the global configuration object if available
declare global {
  interface Window {
    appConfig?: {
      API_BASE_URL: string;
      SUPABASE_URL?: string;
      SUPABASE_KEY?: string;
    };
  }
}

// Get API base URL with fallbacks
export const API_BASE_URL = 
  // First try window.appConfig (runtime config)
  (window.appConfig?.API_BASE_URL) ||
  // Then try NODE_ENV (build-time config)
  (process.env.NODE_ENV === 'production' ? 'https://bank-bonuses-api.onrender.com' : 'http://localhost:8000');

export const IS_PRODUCTION = process.env.NODE_ENV === 'production';

// Supabase configuration
export const SUPABASE_URL = window.appConfig?.SUPABASE_URL || process.env.REACT_APP_SUPABASE_URL || '';
export const SUPABASE_KEY = window.appConfig?.SUPABASE_KEY || process.env.REACT_APP_SUPABASE_KEY || '';

// Helper function to get full API URL
export const getApiUrl = (endpoint: string): string => {
  // Make sure endpoint starts with a slash if it doesn't already
  const formattedEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${API_BASE_URL}${formattedEndpoint}`;
};

// Export config object for convenience
export const config = {
  API_BASE_URL,
  IS_PRODUCTION,
  SUPABASE_URL,
  SUPABASE_KEY,
};
